// extracted by mini-css-extract-plugin
module.exports = {"eventCard":"ImageCarouselCard_eventCard__Rw3_S","name":"ImageCarouselCard_name__kwFgr"};